<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<v-flex xs12 sm6 offset-sm3  >
					<v-card>
						<template v-if="isLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">Hesaplar listesi yükleniyor</div>
							</div>
						</template>
						<template v-if="!isLoading">
							<v-toolbar color="indigo" dark>
								<v-text-field flat solo-inverted hide-details prepend-inner-icon="search" v-model="filterText"
									label="Bir domain ismi ara"></v-text-field>
								<!-- <v-spacer></v-spacer> -->

								<v-btn icon @click="downloadExcell()">
									<v-icon>cloud_download</v-icon>
								</v-btn>
							</v-toolbar>
							<v-select v-model="order" :items="orders" item-text="val" item-value="key"
								label="Şuna göre sırala" class="ml-3 mt-4 mr-3"></v-select>

							<v-list two-line>
								<template v-for="(organization, organizationIndex) in getOrgranziations">
									
										<v-list-tile :key="organizationIndex" avatar @click="loginOrganization(organization)">
											<v-list-tile-avatar>
												<img src="@/assets/default/email.png">
											</v-list-tile-avatar>

											<v-list-tile-content>
												<v-list-tile-title v-html="organization.domain"></v-list-tile-title>
												<v-list-tile-sub-title v-html="organization.account"></v-list-tile-sub-title>
											</v-list-tile-content>

											<v-list-tile-action>
												<v-list-tile-action-text>{{organization.user_count}}</v-list-tile-action-text>
											</v-list-tile-action>
										</v-list-tile>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>

 


			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	export default {
		name: "MailOrganizations",

		data : () => ({
			isLoading: false,
			orders: [{
				key: 0,
				val: 'Ada göre sırala'
			}, {
				key: 1,
				val: 'Mail sayısına göre sırala'
			}],
			order: 0,
			filterText : "",
			organizations : []
		}),

		mounted(){
			this.isLoading = true; 
			this.$http.get( process.env.VUE_APP_API_URL + "/email/organizations/", {
				params : { 
				}
			}).then(response => {  
				this.organizations = response.body;
				this.isLoading = false; 
			}) 
		},

		methods : {
			loginOrganization(organization){
				this.$router.push({ 
					path: '/email/users', query: { 
						account: organization.account, 
						domain_id : organization.domain_id,
						domain : organization.domain
					} 
				})
			},
			downloadExcell(){
				window.open("http://robotic.ajans360.com/api/email/download",'_blank');
			}
		},

		computed : {
			getOrgranziations(){
				var list = []; 
				if(this.filterText != ""){
					var text = this.filterText.toLowerCase();
					list = this.organizations.filter( function(item) {
						return item.domain.indexOf(text) > -1 
					})
				}
				else{
					list = this.organizations;
				}
				if(this.order == 0){
					list.sort(function(a, b) {
						var nameA = a.domain.toUpperCase(); // ignore upper and lowercase
						var nameB = b.domain.toUpperCase(); // ignore upper and lowercase
						if (nameA < nameB) {
							return -1;
						}
						if (nameA > nameB) {
							return 1;
						} 
						return 0;
					});
				}
				if(this.order == 1){
					list.sort(function (a, b) {
						return b.user_count - a.user_count;
					});
				}
				return list;
			}
		}

	}
</script>